import React from "react";
import FoodCard from "./common/FoodCard";
import SearchFilterBtn from "./SearchFilterBtn";
import SearchHeader from "./SearchHeader";
import SortedData from "../data/data.json";
import SearchCategories from "./SearchCategories";

const HighToLow = () => {
  return (
    <div>
      <SearchHeader />
      <SearchFilterBtn />
      <SearchCategories />
      <FoodCard data={SortedData.sort((a, b) => b.itemPrice - a.itemPrice)} />
    </div>
  );
};

export default HighToLow;
